import React from 'react';
import Icon from './Icon';
import './CompanyDetailPanel.css';

/**
 * A company-panel section whose body collapses behind its header: title (+ optional badge) on
 * the left, a chevron on the right, click or Enter/Space to toggle. `actions` renders next to
 * the chevron without toggling the section, for a section's own edit/add controls.
 */
const AccordionSection = ({ id, className = '', title, actions, open, onToggle, children }) => {
  const bodyId = `${id}-body`;
  const titleId = `${id}-title`;
  return (
    <section className={`company-section company-accordion ${className}`.trim()} aria-labelledby={titleId}>
      <div
        className="company-accordion__header"
        role="button"
        tabIndex={0}
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={onToggle}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggle();
          }
        }}
      >
        <h3 id={titleId}>{title}</h3>
        <span className="company-accordion__right">
          {actions && (
            <span
              className="company-accordion__actions"
              onClick={(event) => event.stopPropagation()}
              onKeyDown={(event) => event.stopPropagation()}
            >
              {actions}
            </span>
          )}
          <Icon
            name="chevron-down"
            className={`company-accordion__chevron${open ? ' company-accordion__chevron--open' : ''}`}
          />
        </span>
      </div>
      {open && <div id={bodyId} className="company-accordion__body">{children}</div>}
    </section>
  );
};

export default AccordionSection;
